export default {
  'pages.login.title': 'Sign in',
  'pages.login.brand': 'Liulian AI',
  'pages.login.subtitle': 'Next-gen AI creation platform',
  'pages.login.accountLogin.tab': 'Account',
  'pages.login.emailLogin.tab': 'Email code',
  'pages.login.username.placeholder': 'Username',
  'pages.login.username.required': 'Please enter username',
  'pages.login.username.length': 'Username must be 4-15 characters',
  'pages.login.password.placeholder': 'Password',
  'pages.login.password.required': 'Please enter password',
  'pages.login.password.length': 'Password must be 4-20 characters',
  'pages.login.email.placeholder': 'Email',
  'pages.login.email.required': 'Please enter email',
  'pages.login.email.invalid': 'Invalid email address',
  'pages.login.captcha.placeholder': 'Verification code',
  'pages.login.captcha.required': 'Please enter verification code',
  'pages.login.captcha.get': 'Get code',
  'pages.login.rememberMe': 'Remember me',
  'pages.login.forgotPassword': 'Forgot password',
  'pages.login.submit': 'Sign in',
  'pages.login.registerSuccess': 'Registration successful. Please sign in.',
  'pages.login.resetPasswordSuccess': 'Password updated successfully. Please sign in.',
  'pages.login.success': 'Signed in successfully!',
  'pages.login.failure': 'Sign in failed, please try again.',
  'pages.login.accountLogin.errorMessage': 'Incorrect username or password',
  'pages.login.emailLogin.errorMessage': 'Incorrect email or verification code',
  'pages.login.backHome': 'Back to home',
  'pages.login.captcha.sent': 'Verification code sent to your email',
  'pages.login.captcha.sendFailed': 'Failed to send verification code. Please try again.',
  'pages.login.noAccount': "Don't have an account? {register}",
  'pages.login.registerNow': 'Sign up now',
};
